module.exports = __webpack_public_path__ + "static/media/event.380ce754.jpg";